var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCart01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.861 20.8H3.138L4.146 7.2h15.708zm-1.723-1.6-.77-10.4H5.632l-.77 10.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.645 3.2h8.71v5.245h-1.6V4.8h-5.51v3.645h-1.6z"
}))));
export default SvgIconCart01;